import React, { useEffect } from 'react';
import { Modal } from 'antd';
import event from '~helpers/mixpanel';
import { ShowVideo, VideoDownload } from '~components/svgs';

const TutorialModal = ({ t, visible, onCancel, from }) => {
  useEffect(() => {
    if (visible) {
      event('Viewed Tutorial Page', {
        'Auth Method': from,
      });
    }
  }, [visible]);
  return (
    <Modal centered title="" visible={visible} footer={null} onCancel={onCancel} width={812}>
      <div className="counteroffer-help__modal">
        <h2 className="counteroffer-help__modal-tile">{t('counter.offer.help_modal.summary')}</h2>

        <div className="counteroffer-help__modal-summary-title">
          <span className="counteroffer-help__modal-leftBorder" />
          <span>{t('counter.offer.help_modal.summary_title')}</span>
        </div>
        <div className="counteroffer-help__modal-video-line  counteroffer-help__first">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.accept_video_title')}
          </span>

          <a
            className="counteroffer-help__modal-icon-float"
            href="https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Accept%2C+Counter+or+Reject+a+student's+order"
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
        <div className="counteroffer-help__modal-video-line">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.deep_video_title')}
          </span>

          <a
            className="counteroffer-help__modal-icon-float"
            href="https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Deep+dive+into+a+Counter+offer"
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
        <div className="counteroffer-help__modal-video-line">
          <ShowVideo className="counteroffer-help__modal-icon" />
          <span className="counteroffer-help__modal-video-title">
            {t('counter.offer.help_modal.editing_video_title')}
          </span>
          <a
            className="counteroffer-help__modal-icon-float"
            href="https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Editing+a+Counter+Offer"
            download
          >
            <VideoDownload className="counteroffer-help__modal-icon  " />
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default TutorialModal;
